import type { EnvConfig } from '@weberus/feature-flag/dist/react';

export type FeatureFlagKey = 'feature1' | 'verticalSrp' | 'nolHomeV1' | 'universalSearchV1';

type FeatureFlags = Record<FeatureFlagKey, EnvConfig>;

export const featureFlagsConfig: FeatureFlags = {
  feature1: {
    local: false,
    dev: false,
    qa: false,
    stage: false,
    prod: false,
  },
  verticalSrp: {
    local: true,
    dev: true,
    qa: true,
    stage: true,
    prod: true,
  },
  nolHomeV1: {
    local: true,
    dev: true,
    qa: false,
    stage: false,
    prod: false,
  },
  universalSearchV1: {
    local: true,
    dev: false,
    qa: false,
    stage: false,
    prod: false,
  },
};
